module.exports = __webpack_public_path__ + "img/prisonersofgeography.a70dd1f0.png";